import i18n from "i18next";
import { CountryPath } from "src/entities/CountryPath";

const getCountryName = (countryPath: CountryPath) => {
  // Try to get translated country name
  const translationKey = `countries.${countryPath}`;
  const translated = i18n.t(translationKey);

  // If translation exists (not equal to the key), return it
  if (translated !== translationKey) {
    return translated;
  }

  // Fallback to English names
  switch (countryPath) {
    case "IDN":
      return "Indonesia";
    case "SGP":
      return "Singapore";
    case "PHL":
      return "Philippines";
    case "MYS":
      return "Malaysia";
    case "THA":
      return "Thailand";
    case "VNM":
      return "Vietnam";
    case "AUS":
      return "Australia";
    case "USA":
      return "US";
    case "JPN":
      return "Japan";
    default:
      return "Unknown";
  }
};

export default getCountryName;
